export default __webpack_public_path__ + "static/media/facebook.33a7d61d.svg";